<template>
	<input
		type="radio"
		v-bind="$attrs"
		:id="id"
		:name="name"
		:value="label"
		:placeholder="label"
		@change="$emit('update:modelValue', $event.target.value)"
		:checked="checked"
	/>
	<label :class="`form-check-label mx-2 ${labelClass}`" :for="id">{{
		label
	}}</label>
</template>
<script>
	export default {
		name: "BaseRadio",
		props: {
			id: {
				type: [String, Number],
				default: null,
			},
			label: {
				type: String,
				default: null,
			},
			modelValue: {
				type: [String, Number, Array, Function, Boolean],
				default: null,
			},
			labelClass: {
				type: String,
			},
			name: {
				type: String,
				required: true,
			},
			checked: {
				type: Boolean,
				default: false,
			},
		},
	};
</script>
